var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 744.234,
    height: 655.177,
    viewBox: "0 0 744.234 655.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-94.058 -5.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M657.356,300.753c-3.055,0-6.082.081-9.1.233A179.959,179.959,0,0,0,507.2,167.973L608.978,68.226,548.818,8.069,396.522,159.5H113.19v74.68H321.419L181.643,373.171l-2.073,2.073H297.294l1.489,7.133-.016.072.056.012a179.894,179.894,0,0,0,75.86,111.119,100.6,100.6,0,1,1-195.638-43.66H98.163a180.062,180.062,0,0,0-2.6,30.28c0,98.934,80.5,179.427,179.435,179.427,84.543,0,155.568-58.784,174.468-137.611a180.193,180.193,0,0,0,24.676,1.735c3.055,0,6.086-.08,9.1-.225,19.439,78.07,90.114,136.1,174.122,136.1,98.942,0,179.435-80.493,179.435-179.431S756.3,300.753,657.356,300.753ZM473.727,447.847A103.185,103.185,0,1,1,576.911,344.663,103.189,103.189,0,0,1,473.727,447.847ZM657.356,580.8a100.76,100.76,0,0,1-98.141-78.537A180.034,180.034,0,0,0,650.03,379.877c2.415-.177,4.859-.294,7.326-.294a100.609,100.609,0,0,1,0,201.217Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f3f4f6",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.d14b6d8ad1fc9cc1ce59ee92f8d97493.svg";
export { ForwardRef as ReactComponent };